import React, { useEffect } from 'react'
import F1Table from '../../Components/F1Table/page'
import Banner2 from '../../Components/Banner/Banner2'

const Page = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
    <Banner2 title="WELCOME TO FORMULA ONE" backgroundImage="/assets/images/banner/video-banner-1.jpg"/>
    {/* <DriverSec3/> */}
    <F1Table/>
    </>
  )
}

export default Page